var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import '../../proto/care_locations_pb';
import { Partner } from '../../proto/partners_pb';
import { baseCareLocation } from '../CareLocationHelpers';
export var chelmsfordFamilyPrimaryCareLocation = __assign(__assign({}, baseCareLocation), { name: 'Chelmsford Family Practice', structuredAddress: {
        streetNumber: '10',
        route: 'Adams St',
        locality: 'North Chelmsford',
        administrativeAreaLevel1: 'MA',
        administrativeAreaLevel2: '',
        postalCode: '01863',
        country: '',
        floor: '',
        room: '',
    }, link: 'https://www.chelmsfordfamily.com/', latitude: 42.63894, longitude: -71.38402, schedule: {
        partner: Partner.CHELMSFORDFAMILYWELLFORCE,
        externalId: '',
        slots: [],
        error: '',
        careLocationInternalId: 0,
    } });
export var gilchristMDPrimaryCareLocation = __assign(__assign({}, baseCareLocation), { name: 'Mark G. Gilchrist, MD, LLC', structuredAddress: {
        streetNumber: '4',
        route: 'Meeting House Rd',
        locality: 'Chelmsford',
        administrativeAreaLevel1: 'MA',
        administrativeAreaLevel2: '',
        postalCode: '01824',
        country: '',
        floor: '',
        room: '',
    }, link: 'https://www.childdocs.com/', phone: '978-250-4081', latitude: 42.60267, longitude: -71.35104, schedule: {
        partner: Partner.GILCHRISTMDWELLFORCE,
        externalId: '',
        slots: [],
        error: '',
        careLocationInternalId: 0,
    } });
export var merrimackFamilyMedPrimaryCareLocation = __assign(__assign({}, baseCareLocation), { name: 'Merrimack Family Medicine', structuredAddress: {
        streetNumber: '600',
        route: 'Clark Rd',
        locality: 'Tewksbury',
        administrativeAreaLevel1: 'MA',
        administrativeAreaLevel2: '',
        postalCode: '01876',
        country: '',
        floor: '',
        room: 'Suite 3',
    }, link: 'https://merrimackfamilymedicine.com/', latitude: 42.63127, longitude: -71.27021, schedule: {
        partner: Partner.MERRIMACKFAMILYMEDWELLFORCE,
        externalId: '',
        slots: [],
        error: '',
        careLocationInternalId: 0,
    } });
export var merrimackValleyInternalMedPrimaryCareLocation = __assign(__assign({}, baseCareLocation), { name: 'Merrimack Valley Internal Medicine Associates', structuredAddress: {
        streetNumber: '20',
        route: 'Research Place',
        locality: 'North Chelmsford',
        administrativeAreaLevel1: 'MA',
        administrativeAreaLevel2: '',
        postalCode: '01863',
        country: '',
        floor: '',
        room: 'Suite 310',
    }, link: 'https://mvinternalmed.com/', latitude: 42.62512, longitude: -71.36454, internalId: 0, schedule: {
        partner: Partner.MERRIMACKVALLEYINTERNALMEDWELLFORCE,
        externalId: '',
        slots: [],
        error: '',
        careLocationInternalId: 0,
    } });
export var millCityMedPrimaryCareLocation = __assign(__assign({}, baseCareLocation), { name: 'Mill City Medical', structuredAddress: {
        streetNumber: '595',
        route: 'Pawtucket Blvd',
        locality: 'Lowell',
        administrativeAreaLevel1: 'MA',
        administrativeAreaLevel2: '',
        postalCode: '01854',
        country: '',
        floor: '',
        room: '',
    }, link: 'https://www.millcitymed.com/', latitude: 42.64092, longitude: -71.35553, schedule: {
        partner: Partner.MILLCITYMEDWELLFORCE,
        externalId: '',
        slots: [],
        error: '',
        careLocationInternalId: 0,
    } });
export var riversideMedPrimaryCareLocation = __assign(__assign({}, baseCareLocation), { name: 'Riverside Medical Group', structuredAddress: {
        streetNumber: '9',
        route: 'Loon Hill Road',
        locality: 'Dracut',
        administrativeAreaLevel1: 'MA',
        administrativeAreaLevel2: '',
        postalCode: '01826',
        country: '',
        floor: '',
        room: 'Unit 201',
    }, link: 'https://riversidemed.com', latitude: 42.67151, longitude: -71.29419, schedule: {
        partner: Partner.RIVERSIDEMEDWELLFORCE,
        externalId: '',
        careLocationInternalId: 0,
        slots: [],
        error: '',
    } });
